import React from "react";
import styled from "styled-components";
import LSRgH1HeadLine from "../text/linSeedKr/Rg/lsRgH1HeadLine";

const StyledSubCategoryItem = ({ onClick, isActive, title }) => {
  return (
    <SubTab onClick={onClick}>
      <SubTabTextWrapper isActive={isActive}>
        <LSRgH1HeadLine
          style={{
            color: "#101113",
          }}
        >
          {title}
        </LSRgH1HeadLine>
      </SubTabTextWrapper>
    </SubTab>
  );
};

export default StyledSubCategoryItem;

const SubTab = styled.button.attrs((props) => {})`
  width: 175px;
  height: 42px;
  display: flex;
  align-items: center;
  padding: 5px 10px;
`;

const SubTabTextWrapper = styled.div.attrs((props) => {})`
  display: flex;
  align-items: center;
  width: fit-content;
  height: ${(props) => (props.isActive ? "32px" : "22px")};
  border-bottom: ${(props) => (props.isActive ? "2px solid #5050FF" : "none")};

  &:hover {
    border-bottom: 2px solid #5050ff;
    height: 32px;
  }
`;
